export const GRAPH_REQUEST = 'product-graph/GRAPH_REQUEST';
export const GRAPH_SUCCESS = 'product-graph/GRAPH_SUCCESS';
export const GRAPH_FAIL = 'product-graph/GRAPH_FAIL';

export const productGraphRequest = ({ id }) => ({
  type: GRAPH_REQUEST,
  payload: { id },
});

export const productGraphSuccess = ({ graph, id }) => ({
  type: GRAPH_SUCCESS,
  payload: { graph, id },
});

export const productGraphFail = ({ error }) => ({
  type: GRAPH_FAIL,
  payload: { error },
});
